<template>
  <div class="vipProductList-box">
    <div class="previewsbox flex just-center" v-if="filterTableList && filterTableList.length > 0">
      <ul class="flex ">
        <li v-for="(item,index) in filterTableList" :key="index" class="pitem">
          <div class="flex just-center  align-item-center">
            <img-load
                height="30px"
                v-if="showImgLoad && item.img"
                :src="imgUrl + '/' + item.img"
            ></img-load>
            <div class="ml-10">
              <div class="fz12">{{ item.name }}</div>
              <div class="fz11">{{ item.desc }}</div>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="flex align-item-baseline mt-8 mb-6">
      <el-select
          v-model.number="params.ctype"
          @change="handleQuery"
          placeholder="任务类型"
          size="small"
          clearable
      >
        <el-option
            :key="1"
            label="萌新任务"
            :value="1"
        ></el-option>
        <el-option
            :key="0"
            label="每日任务"
            :value="0"
        ></el-option>
      </el-select>
      <el-select
          v-model.number="params.status"
          @change="handleQuery"
          placeholder="发布状态"
          size="small"
          class="ml-5"
          clearable
      >
        <el-option
            :key="1"
            label="开启"
            :value="1"
        ></el-option>
        <el-option
            :key="0"
            label="关闭"
            :value="0"
        ></el-option>
      </el-select>
      <div class="ml-5">
        <el-button
            type="success"
            size="small"
            @click="handleQuery()"
            class="add-input"
        >搜索
        </el-button>
      </div>
      <div class="ml-10">
        <el-button
            type="primary"
            size="small"
            @click="handleOpenEdit('add', tableData)"
            class="add-input"
        >+新增
        </el-button>
      </div>
      <div class="ml-10">
        <el-button
            type="primary"
            size="small"
            @click="handleQuery()"
            class="add-input"
        >刷新
        </el-button>
      </div>
    </div>
    <!--数据表格-->
    <el-table
        :data="tableData"
        border
        size="small"
        height="calc(100vh - 100px)"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading"
    >
      <el-table-column label="序列" align="center" width="58">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="dtype" label="图标" align="center" width="60">
        <template slot-scope="scope">
          <img-load
              width="40px"
              v-if="showImgLoad && scope.row.img"
              :src="imgUrl + '/' + scope.row.img"
          ></img-load>
          <span v-else>暂无图片</span>
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="标题" align="center" min-width="140">
        <template slot-scope="scope">
          <el-input v-model.number="scope.row.name" class="center-input"
                    @blur="handlerField('name',scope.$index,false)"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="任务类型" align="center" width="140">
        <template slot-scope="scope">
          <el-select v-model.number="scope.row.ctype"  @change="handlerField('ctype',scope.$index,true)">
            <el-option :value="1" label="萌新任务"></el-option>
            <el-option :value="0" label="每日任务"></el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column prop="dtype" width="100" label="福利类型" align="center">
        <template slot-scope="scope">
          <span v-if="scope.row.qtype==1">获取积分</span>
          <span v-if="scope.row.qtype==2">获得VIP</span>
          <span v-if="scope.row.qtype==3">获得观影券</span>
        </template>
      </el-table-column>
      <el-table-column prop="dtype" label="应用类型" align="center" width="120">
        <template slot-scope="scope">
          <span v-if="scope.row.dtype==1">每日登录</span>
          <span v-if="scope.row.dtype==2">每日发帖</span>
          <span v-if="scope.row.dtype==3">每日评论</span>
          <span v-if="scope.row.dtype==4">下载应用</span>
          <span v-if="scope.row.dtype==5">购买VIP</span>
          <span v-if="scope.row.dtype==6">购买金币作品</span>
          <span v-if="scope.row.dtype==7">保存账号凭证</span>
          <span v-if="scope.row.dtype==8">每日邀请</span>
          <span v-if="scope.row.dtype==9">每日点赞</span>
          <span v-if="scope.row.dtype==10">充值金币</span>
          <span v-if="scope.row.dtype==11">每日收藏</span>
        </template>
      </el-table-column>
      <el-table-column prop="points" label="获得积分" align="center" width="100">
        <template slot-scope="scope">
          <el-input v-model.number="scope.row.points" :disabled="scope.row.qtype == 3" class="center-input"
                    @blur="handlerField('points',scope.$index,true)"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="desc" label="文案描述" align="center" width="240">
        <template slot-scope="scope">
          <el-input v-model.number="scope.row.desc" class="center-input"
                    @blur="handlerField('desc',scope.$index,false)"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="href" label="链接" align="center" width="70">
        <template slot-scope="scope">
          <span v-if="scope.row.href">有链接</span>
        </template>
      </el-table-column>
      <el-table-column prop="vipDays" label="获得观影券面值/张" align="center" width="200" v-if="false">
        <template slot-scope="scope">
          <div class="flex align-item-center">
            <el-input v-model.number="scope.row.qnum" class="center-input ml-5" :disabled="scope.row.qtype != 3"
                      @blur="handlerField('qnum',scope.$index,true)"></el-input>
            <span class="ml-3 mr-2">张</span>
            <el-input v-model.number="scope.row.qprice" class="center-input" :disabled="scope.row.qtype != 3"
                      @blur="handlerField('qprice',scope.$index,true)"></el-input>
            <span class="ml-3 mr-2">元</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="sorted" label="排序" align="center" width="100">
        <template slot-scope="scope">
          <el-input v-model.number="scope.row.sorted" class="center-input"
                    @blur="handlerField('sorted',scope.$index,true)"></el-input>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="发布状态" align="center" width="160">
        <template slot-scope="scope">
          <el-switch
              v-model.number="scope.row.status"
              active-color="#13ce66"
              class="fz12"
              inactive-color="#909399"
              :active-value="1"
              :inactive-value="0"
              active-text="开启"
              @change="handlerField('status',scope.$index,true)"
              inactive-text="关闭">
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column prop="updatedAt" label="更新时间" align="center" width="160" v-if="false">
        <template slot-scope="scope">
          <span>{{ scope.row.updatedAt | changeDate }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" fixed="right" width="180">
        <template slot-scope="scope">
          <el-button
              type="success"
              size="mini"
              icon="el-icon-edit"
              @click="handleOpenEdit('edit', scope.row)"
          ></el-button>
          <el-button
              type="info"
              size="mini"
              title="快速复制"
              icon="el-icon-document-copy"
              @click="handlerCopy( scope.row.id)"
          ></el-button>
          <el-button
              type="danger"
              size="mini"
              icon="el-icon-delete"
              @click="handleRemove(scope.row)"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--新增、编辑弹框-->
    <addedit
        ref="positionAction"
        @callback="handlerList"
    ></addedit>
  </div>
</template>
<script>
import API from "@/api/checkTaskApi";
import addedit from "./components/addedit";
import baseConfig from "@/utils/serverUrlConfig";

export default {
  data() {
    return {
      // 表格数据加载动画
      loading: false,
      imgUrl: baseConfig.imgUrl,
      showImgLoad: false,
      tableData: [],
      // 列表请求参数
      params: {
        status: "",
        ctype: ""
      },
    };
  },
  components: {
    addedit,
  },
  created() {
    this.handlerListMain(this.params);
  },
  computed: {
    baseConfig() {
      return baseConfig
    },
    filterTableList() {
      return this.tableData && this.tableData.length > 0 &&  this.tableData.filter(c => c.status == 1).sort((a, b) => a.sorted - b.sorted)
    }
  },
  methods: {
    // 标签封面上传成功回掉
    handleUploadSuccess(res) {
      this.params.img = res.data.coverImg;
      this.$forceUpdate();
    },
    // 请求商品列表
    handlerListMain() {
      this.loading = true;
      API.list(this.params)
          .then((res) => {
            this.showImgLoad = true;
            if (res.code === 200 && res.data &&  res.data.length > 0) {
              this.tableData = res.data;
            }else{
              this.tableData = [];
            }
            this.loading = false;
          })
          .catch(() => {
            this.showImgLoad = false;
            this.loading = false;
          });
    },

    handleQuery() {
      this.handlerListMain()
    },

    // 监听编辑、或者添加成功过后重新拉去数据
    handlerList() {
      this.handlerListMain();
    },

    // 快速修改值
    handlerField(field, index, flag) {
      var id = this.tableData[index].id
      var value = this.tableData[index][field]
      if (flag) value = parseInt(value)
      API.field({id: id, field: field, value: value}).then(res => {
        if (res.code === 200) {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.handlerListMain();
        } else {
          this.$message.error("复制失败！");
        }
      })
    },

    // 快速复制
    handlerCopy(id) {
      API.copy({id: id}).then(res => {
        if (res.code === 200) {
          this.$message({
            message: "复制成功",
            type: "success",
          });
          this.handlerListMain();
        } else {
          this.$message.error("复制失败！");
        }
      })
    },
    // 删除管理员
    handleRemove(row) {
      this.$confirm("您确定要删除当前项吗？", "删除提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        API.remove({id: row.id}).then((res) => {
          if (res.code === 200) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.handlerListMain();
          } else {
            this.$message.error("删除失败！");
          }
        });
      });
    },
    // 新增、编辑操作
    handleOpenEdit(type, data) {
      if (type == 'add') data.sorted = this.tableData.length + 1
      this.$refs.positionAction.open(type, data);
    },
  },
};
</script>

<style scoped lang="scss">
.vipProductList-box {
  display: flex;
  height: 100%;
  flex-direction: column;
}

.previewsbox {
  background: #eee;
  padding: 20px 10px;
  border-radius: 4px;
  margin: 5px 0;
  min-height: 100px;

  .pitem {
    margin: 0 10px;
    font-size: 11px;
    padding: 10px;
    background-color: #ffab00;
    display: flex;
    border-radius: 10px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
    font-weight: 1000;

    &:hover {
      color: #fff;
    }
  }
}
</style>
